module.exports = __webpack_public_path__ + "static/media/footer_xanhnhat.fb721529.png";